<template>
  <yd-dialog
    :title="imgData.title"
    :visible.sync="visible"
    append-to-body
    @close="closeChoose"
    @open="init"
  >
    <div class="flex-between">
      <div class="flex-start">
        <i class="el-icon-warning-outline color-999 font-16"></i>
        <span class="font-14 color-999 margin-left-5">
          <!-- jpg/png/gif格式，大小100*100，不超过1M。 -->
          {{ imgData.text }}
        </span>
      </div>
      <div>
        <el-button type="primary" @click="addImg" plain size="mini">上传图片</el-button>
      </div>
    </div>
    <el-radio-group v-model="imageUrl" style="width: 100%">
      <div style="height: 300px; width: 100%" v-loading="loading" class="flex flex-wrap">
        <div
          v-for="item in tableData"
          :key="item.id"
          class="margin-right-20 flex-center image flex-col"
        >
          <imagePreview :imgObj="item" @remove="handleRemove" />
          <el-radio :label="item.img" class="margin-top-10 full-x text-eli">
            {{ item.imgName }}
          </el-radio>
        </div>
        <div v-if="!tableData || !tableData.length" class="flex-center full-x">
          <el-empty description="暂无图片" image-size="80" />
        </div>
      </div>
    </el-radio-group>
    <div class="flex flex-justify-end pagina">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageState.currentPage"
        :page-sizes="[1, 10, 20, 50, 100]"
        :page-size="pageState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageState.total"
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeChoose">取 消</el-button>
      <el-button type="primary" @click="saveImage">保 存</el-button>
    </div>
    <yd-dialog title="上传图片" :visible.sync="addImgShow" append-to-body @close="close">
      <UploadImage
        :isMultiple="true"
        :limit="10"
        @uploadSuccess="handleSuccess"
        code="icon-user"
        :size="1"
        :customTip="customTip"
        :accept="imgData.accept"
        :width="imgData.width || 100"
        :height="imgData.height || 100"
        v-if="addImgShow"
      />
      <!-- <UploadImage
        :isMultiple="true"
        :limit="10"
        @input="handleSuccess"
        :width="80"
        :height="80"
        code="icon-user"
      /> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="saveUploadImage">保 存</el-button>
      </div>
    </yd-dialog>
  </yd-dialog>
</template>

<script >
import { iconPage, iconSave, iconRemove } from '@/api/marketing/advertising';
import { computed, ref } from '@vue/composition-api';
import { useTableList } from '@/hooks';
import UploadImage from '@/components/newUpload/index.vue';
import imagePreview from './image-preview.vue';
import { Message } from 'element-ui';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    type: Boolean,
    default: false
  },
  imgData: {
    type: Object,
    default: () => {
      return {
        fetchApi: 1,
        title: '选择图片',
        text: 'jpg/png/gif格式，大小100*100，不超过1M。',
        size: [100, 100],
        ram: 1,
        type: '.jpg,.png,.jpeg,.gif'
      };
    }
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emits = __ctx.emit;
  const visible = computed(() => props.visible);
  const addImgShow = ref(false);
  const imgList = ref([]);
  const imageUrl = ref('');
  // const previewImg = ref(null)

  const {
    loading,
    tableData,
    pageState,
    handleCurrentChange,
    handleSizeChange,
    search
    // reset
  } = useTableList(iconPage, {
    type: props.imgData.fetchApi
  });
  const addImg = () => {
    addImgShow.value = true;
  };
  const close = () => {
    addImgShow.value = false;
  };
  // 图片上传成功
  const handleSuccess = file => {
    console.log(3333, file);
    if (file.length) {
      imgList.value = file.map(item => item.url);
      console.log(3333, imgList.value);
    }
  };
  const saveUploadImage = async () => {
    if (imgList.value.length === 0 && props.imgData.fetchApi !== 1) {
      Message.error(`请上传尺寸为${props.imgData.width}*${props.imgData.height}，大小2M的图片`);
      return;
    }
    const {
      code
    } = await iconSave({
      img: imgList.value,
      type: props.imgData.fetchApi
    });
    if (code === 0) {
      close();
      search();
    }
  };
  const handleRemove = async id => {
    const {
      code
    } = await iconRemove(id);
    if (code === 0) {
      search();
    }
  };
  const closeChoose = () => {
    emits('closeChoose');
  };
  const saveImage = () => {
    if (props.imgData.fetchApi === 1) {
      emits('saveImage', imageUrl.value);
    } else {
      emits('saveImage', {
        val: imageUrl.value,
        type: props.imgData.fetchApi
      });
    }
  };
  const customTip = data => {
    console.log('数据', data);
    const {
      imgWidth,
      imgHeight,
      width,
      height
    } = data;
    let message = '';
    if (props.imgData.fetchApi === 1) {
      message = '尺寸不符，请修改尺寸后重新上传！';
    } else {
      message = `请上传尺寸为${props.imgData.width}*${props.imgData.height}的图片`;
    }
    return new Promise(resolve => {
      if (imgWidth !== width || height !== imgHeight) {
        Message.error({
          message
        });
        resolve(false);
      } else {
        resolve(true);
      }
    });
  };
  return {
    visible,
    addImgShow,
    imageUrl,
    loading,
    tableData,
    pageState,
    handleCurrentChange,
    handleSizeChange,
    addImg,
    close,
    handleSuccess,
    saveUploadImage,
    handleRemove,
    closeChoose,
    saveImage,
    customTip
  };
};
__sfc_main.components = Object.assign({
  imagePreview,
  UploadImage
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .avatar {
    &:hover {
      .operate {
        visibility: visible;
      }
    }

    width: 100px;
    height: 100px;
    display: block;
    position: relative;
    background: rgb(217, 236, 255);
    border-radius: 6px;
  }

  .operate {
    visibility: hidden;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    z-index: 100;
    box-sizing: border-box;
    background-color: #909399;
  }

  .image {
    box-sizing: border-box;
    width: 17%;
    height: 150px;
    // background: #f5f5f5;
    // border-radius: 34rpx;

    &:not(:nth-child(5n)) {
      /*计算出三个间距大小，平分即可*/
      margin-right: calc(8% / 4);
    }
  }
</style>
